export default __webpack_public_path__ + "static/media/icon-edit.624705dd.svg";